// src/pages/MallApp.js
// Mall Admin dashboard — mall tabs only, no vendor tabs, no super admin
// Shown after mall admin login

import React, { useState, useEffect } from 'react';
import { useAuth }       from '../context/AuthContext';
import { useLanguage }   from '../context/LanguageContext';
import { getMall }       from '../services/session';
import LangToggle        from '../components/LangToggle';
import MallAdminPanel    from './MallAdminPanel';
import TestModeBanner    from '../components/TestModeBanner';

const MALL_TABS = [
  { id:'kiosk', label:'🏬 Multi-Vendor Kiosk' },
  { id:'mall',  label:'🏛 Mall Admin'         },
];

export default function MallApp() {
  const { mallAdmin, logout } = useAuth();
  const { isAr }              = useLanguage();
  const [tab, setTab]         = useState('mall');
  const [mallSlug, setMallSlug] = useState(null);

  useEffect(() => {
    if (!mallAdmin?.mallId) return;
    getMall(mallAdmin.mallId).then(r => setMallSlug(r.data?.slug)).catch(() => {});
  }, [mallAdmin]);

  // Launch screen for the customer-facing entrance kiosk
  if (tab === 'kiosk') return (
    <div>
      <TestModeBanner />
      <div className="nav" style={{ flexWrap:'wrap', gap:6, direction: isAr ? 'rtl' : 'ltr' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div className="nav-logo">⚡ QuickServe</div>
          <span style={{ fontSize:11, padding:'2px 8px', borderRadius:10, background:'#3d2e10', color:'var(--accent)' }}>Mall Admin</span>
        </div>
        <div className="nav-tabs" style={{ flexWrap:'wrap' }}>
          {MALL_TABS.map(tb => (
            <button key={tb.id} className={`nav-tab${tab===tb.id?' active':''}`} onClick={() => setTab(tb.id)}>{tb.label}</button>
          ))}
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <LangToggle />
          <button className="btn btn-ghost btn-sm" onClick={logout}>Logout</button>
        </div>
      </div>

      <div style={{ padding:40, maxWidth:560, margin:'0 auto', textAlign:'center' }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🖥</div>
        <div style={{ fontSize:20, fontWeight:700, marginBottom:10 }}>Customer-Facing Entrance Kiosk</div>
        <div style={{ fontSize:14, color:'var(--text2)', marginBottom:24 }}>
          Opens the full-screen, multi-vendor kiosk customers use at the food court entrance.
        </div>
        <button
          className="btn btn-primary"
          disabled={!mallSlug}
          style={{ padding:'16px 32px', fontSize:16 }}
          onClick={() => window.open(`/kiosk/mall/${mallSlug}`, '_blank')}>
          🖥 Launch Full-Screen Kiosk
        </button>
        <div style={{ fontSize:12, color:'var(--text3)', marginTop:16 }}>
          Note: Set this as the browser homepage on your kiosk tablet.
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <TestModeBanner />
      {/* Mall nav */}
      <div className="nav" style={{ flexWrap:'wrap', gap:6, direction: isAr ? 'rtl' : 'ltr' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div className="nav-logo">⚡ QuickServe</div>
          <span style={{ fontSize:11, padding:'2px 8px', borderRadius:10, background:'#3d2e10', color:'var(--accent)' }}>
            Mall Admin
          </span>
        </div>

        {/* Only mall tabs */}
        <div className="nav-tabs" style={{ flexWrap:'wrap' }}>
          {MALL_TABS.map(tb => (
            <button key={tb.id}
              className={`nav-tab${tab===tb.id?' active':''}`}
              onClick={() => setTab(tb.id)}>
              {tb.label}
            </button>
          ))}
        </div>

        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <LangToggle />
          <div style={{ fontSize:12, color:'var(--text2)' }}>
            🏬 {mallAdmin?.name || mallAdmin?.email}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={logout}>Logout</button>
        </div>
      </div>

      {/* Tab content */}
      {tab === 'mall' && <MallAdminPanel />}
    </div>
  );
}
